import React from 'react';

const FixProblems = () => {
  return <div className="text-2xl font-sora text-driveeasy-blue">FixProblems Page</div>;
};

export default FixProblems;